import { v4 as uuidv4 } from 'uuid';

import { Blocks } from '@/components/Blocks';
import { Block, BlockFormats } from '@/types';

const header = {
  items: [
    { UUID: uuidv4(), title: 'Podcasts gratuits', route: '' },
    { UUID: uuidv4(), title: 'Nouveautés', route: '' },
    { UUID: uuidv4(), title: 'Nos plus grands succès', route: '' },
    { UUID: uuidv4(), title: 'Les séries de l’été', route: '' },
    { UUID: uuidv4(), title: "Ils font l'actualité", route: '' },
    { UUID: uuidv4(), title: 'Dernières sorties', route: '' },
  ],
  title: '',
  format: BlockFormats.HeaderCarousel,
  size: 'header',
} as Block;

const block = {
  items: [
    { UUID: uuidv4(), title: 'Podcasts gratuits', route: '' },
    { UUID: uuidv4(), title: 'Nouveautés', route: '' },
    { UUID: uuidv4(), title: 'Nos plus grands succès', route: '' },
    { UUID: uuidv4(), title: 'Les séries de l’été', route: '' },
    { UUID: uuidv4(), title: "Ils font l'actualité", route: '' },
    { UUID: uuidv4(), title: 'Dernières sorties', route: '' },
  ],
  title: '',
  format: BlockFormats.HighCarousel,
  size: 'default',
} as Block;

const blocks = [
  { ...header, title: '' },
  { ...block, title: 'Podcasts gratuits' },
  { ...block, title: 'Nouveautés' },
  { ...block, title: 'Nos plus grands succès' },
  { ...block, title: 'Les séries de l’été' },
  { ...block, title: 'Ils font l’actualité' },
  { ...block, title: 'Dernières sorties' },
];

export const HomeLoader = () => {
  return (
    <div className="w-full animate-pulse loader">
      <Blocks blocks={blocks} />
    </div>
  );
};
